export default __webpack_public_path__ + "static/media/rew.99d76660.png";